import { NgModule } from '@angular/core';

import {
    CalendarModule,
    DatePickerModule,
    DateRangePickerModule,
} from '@syncfusion/ej2-angular-calendars';
import {
    AccumulationChartModule,
    AccumulationDataLabelService,
    AccumulationLegendService,
    ChartModule,
    ColumnSeriesService,
    DataLabelService,
    DateTimeCategoryService,
    DateTimeService,
    LegendService,
    LineSeriesService,
    PieSeriesService,
    TooltipService,
} from '@syncfusion/ej2-angular-charts';
import {
    AutoCompleteModule,
    CheckBoxSelectionService,
    DropDownListModule,
    MultiSelectModule,
} from '@syncfusion/ej2-angular-dropdowns';
import {
    ExcelExportService,
    FilterService,
    GridModule,
    GroupService,
    PageService,
    ResizeService,
    SortService,
} from '@syncfusion/ej2-angular-grids';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { ProgressBarModule } from '@syncfusion/ej2-angular-progressbar';

@NgModule({
    imports: [
        DatePickerModule,
        DateRangePickerModule,
        CalendarModule,

        AccumulationChartModule,
        ChartModule,
        DashboardLayoutModule,
        ProgressBarModule,
        TabModule,

        AutoCompleteModule,
        DropDownListModule,
        MultiSelectModule,
        TextBoxModule,
        GridModule,
    ],
    exports: [
        DatePickerModule,
        DateRangePickerModule,
        CalendarModule,

        AccumulationChartModule,
        ChartModule,
        DashboardLayoutModule,
        ProgressBarModule,
        TabModule,

        AutoCompleteModule,
        DropDownListModule,
        MultiSelectModule,
        TextBoxModule,
        GridModule,
    ],
    providers: [
        AccumulationDataLabelService,
        AccumulationLegendService,
        ColumnSeriesService,
        DataLabelService,
        DateTimeCategoryService,
        DateTimeService,
        LegendService,
        LineSeriesService,
        PieSeriesService,
        TooltipService,
        CheckBoxSelectionService,
        ExcelExportService,
        FilterService,
        GroupService,
        PageService,
        SortService,
        ResizeService,
    ],
})
export class SyncfusionSharedModule { }
